import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

let isGenerating = false;

const borderStyle = {
  top: { style: "thin", color: { rgb: "000000" } },
  bottom: { style: "thin", color: { rgb: "000000" } },
  left: { style: "thin", color: { rgb: "000000" } },
  right: { style: "thin", color: { rgb: "000000" } }
};

export const excelReport = async (
  columns,
  data,
  filename = "Report.xlsx",
  reportTitle = "Report"
) => {

  if (isGenerating) return;
  isGenerating = true;

  try {
    const headers = columns.map(col =>
      typeof col.Header === "string" ? col.Header : "Column"
    );

    const rows = data.map(row => {
      const r = {};
      columns.forEach(col => {
        let value =
          typeof col.accessor === "string"
            ? row[col.accessor]
            : typeof col.accessor === "function"
            ? col.accessor(row)
            : null;

        if (typeof value === "number" && value > 9999999) {
          value = String(value);
        }

        r[col.Header] = value;
      });
      return r;
    });

    const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });

    XLSX.utils.sheet_add_aoa(worksheet, [[reportTitle]], { origin: "A1" });

    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }
    ];

    worksheet["A1"].s = {
      font: { bold: true, sz: 16 },
      alignment: { horizontal: "center", vertical: "center" },
      border: borderStyle
    };

    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A2" });

    XLSX.utils.sheet_add_json(worksheet, rows, {
      origin: "A3",
      skipHeader: true
    });

    worksheet["!cols"] = headers.map(header => {
      let maxLen = header.length;
      rows.forEach(row => {
        const val = row[header];
        if (val != null) {
          maxLen = Math.max(maxLen, val.toString().length);
        }
      });
      return { wch: maxLen + 4 };
    });

    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const ref = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[ref];
        if (!cell) continue;

        if (R === 0) continue;

        if (R === 1) {
          cell.s = {
            font: { bold: true, sz: 12 },
            alignment: { horizontal: "left", vertical: "center" },
            border: borderStyle
          };
          continue;
        }

        cell.s = {
          alignment: { horizontal: "left", vertical: "center" },
          border: borderStyle
        };

        if (typeof cell.v === "string" && /^\d{10,}$/.test(cell.v)) {
          cell.t = "s";
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    saveAs(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }),
      filename
    );

  } finally {
    isGenerating = false;
  }
};
